import { useEffect, useState } from 'react';

/**
 * The value, settled — it only changes once `delay` has passed without a new
 * one arriving.
 *
 * Used to keep a search box instant while the request behind it is not: the
 * input stays controlled and echoes every keystroke, but the query key (and so
 * the fetch) only moves when the typing stops.
 */
export function useDebounce<T>(value: T, delay = 250): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return settled;
}
